import React from "react"

import styles from "./Legend.module.css"

import { LegendItem } from "./LegendItem"

type Props = {
  children: React.ReactNode
}

const Legend = (props: Props) => {
  const { children } = props
  return <div className={styles.container}>{children}</div>
}

Legend.Item = LegendItem

export { Legend }
